import cardHsiaTextWithIcon from './card-hsia-text-with-icon';

export default cardHsiaTextWithIcon;
